module.exports = __webpack_public_path__ + "img/phone-entry.9141ad8f.png";